export const ALL_ACCOUNTS = "All Accounts" as const;
export const EMAIL_VERIFICATION_REQUIRED_DATE = "2025-04-19";
